import { isNullOrUndefined } from '@common/validations/types.validation';
import Icon from '@material-ui/core/Icon';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

import { useObservable } from '~/@components/@hooks/use-observable';
import { COLORS } from '~/@components/@theme/colors';
import { Chip } from '~/@components/Chip';
import { removeEmptyKeys } from '~/@store/common';
import { userProjectsStore, UserRelationField } from '~/@store/users';
import i18n from '~/i18n';

import { formatFilterValue } from '../../../common/utils';

const FieldNames: Record<UserRelationField, string> = {
    [UserRelationField.name]: i18n.UserCard.projects.project,
};

export const UserProjectsFilterSummary = () => {
    const filterValues = useObservable(() => removeEmptyKeys({ ...userProjectsStore.filter.values }));
    const { root, chip } = useStyles();

    return (
        <div className={root}>
            {Object.keys(filterValues).map(objectKey => {
                const key = objectKey as UserRelationField;
                const value = filterValues[key];
                if (isNullOrUndefined(value)) return null;

                const chipContent = `${FieldNames[key]}: "${formatFilterValue(value)}"`;

                return (
                    <Chip
                        key={key}
                        className={chip}
                        color={COLORS.black}
                        onDelete={() => userProjectsStore.filter.setValue(key, null)}
                        deleteIcon={<Icon>close</Icon>}>
                        {chipContent}
                    </Chip>
                );
            })}
        </div>
    );
};

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
    },
    chip: {
        marginRight: theme.spacing(1),
    },
}));
